const history = require('history');

const browserHistory = history.createHashHistory();

export default browserHistory;
